import { ClockIcon, StarIcon, Wallet2Icon } from 'lucide-react';
import type { ComponentProps } from 'react';
import type { Store } from '../types/get-stores';

type StoreLineInfoProps = ComponentProps<'div'> & {
  store: Partial<Pick<Store, 'rating' | 'delivery_time' | 'min_order_price'>>;
  /** Quantidade de avaliações (últimos 30 dias), exibida ao lado da nota. */
  ratingCount?: number;
  /** Quando informado, a nota vira botão (ex.: abrir a lista de avaliações). */
  onRatingClick?: () => void;
};

export function StoreLineInfo({ store, ratingCount, onRatingClick, ...props }: StoreLineInfoProps) {
  return (
    <div className="flex items-center justify-start gap-2" {...props}>
      {/** Store Rating (PRAT-43: clicável para ver as avaliações) */}
      {!!store?.rating && onRatingClick && (
        <button
          type="button"
          onClick={onRatingClick}
          className="flex items-center gap-1 min-h-6 -my-1 py-1 pr-1 cursor-pointer"
          aria-label={`Nota ${store.rating}. Ver avaliações`}
        >
          <StarIcon className="w-2.5 h-2.5 text-[#f2c94c] fill-[#f2c94c]" />
          <span className="text-xs font-sans text-muted-foreground">
            {store.rating}
            {ratingCount ? ` (${ratingCount})` : ''}
          </span>
          <span className="text-xs font-sans text-primary underline underline-offset-2">
            avaliações
          </span>
        </button>
      )}
      {!!store?.rating && !onRatingClick && (
        <div className="flex items-center gap-1">
          <StarIcon className="w-2.5 h-2.5 text-[#f2c94c] fill-[#f2c94c]" />
          <p className="text-xs font-sans text-muted-foreground">{store.rating}</p>
        </div>
      )}

      {/** Store Delivery Time */}
      {!!store?.delivery_time && (
        <div className="flex items-center gap-1">
          <ClockIcon className="w-2.5 h-2.5 text-muted-foreground" />
          <p className="text-xs font-sans text-muted-foreground">{store.delivery_time}</p>
        </div>
      )}

      {/** Store Min Order Price */}
      {!!store?.min_order_price && (
        <div className="flex items-center gap-1">
          <Wallet2Icon className="w-2.5 h-2.5 text-muted-foreground" />
          <p className="text-xs font-sans text-muted-foreground">
            {Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(Math.floor(Number(store.min_order_price)))}
          </p>
        </div>
      )}
    </div>
  );
}
